import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EmployerOnboardingScreens } from 'src/constants/onboarding';

import { validateOTP } from 'src/redux/actions/employerLayout';
import { RootState } from 'src/redux/index';

export interface EmployerOnboardingState {
  validateOtp: boolean;
  currentScreen: EmployerOnboardingScreens;
}

const initialState: EmployerOnboardingState = {
  validateOtp: false,
  currentScreen: EmployerOnboardingScreens.AboutYou,
};

/* eslint-disable no-param-reassign */
const employerOnboardingSlice = createSlice({
  name: 'employerOnboarding',
  initialState,
  reducers: {
    setCurrentScreen: (
      state,
      action: PayloadAction<EmployerOnboardingScreens>,
    ) => {
      state.currentScreen = action.payload;
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(validateOTP.fulfilled, (state) => {
      state.validateOtp = true;
    });
    builder.addCase(validateOTP.rejected, (state) => {
      state.validateOtp = false;
    });
  },
});

/* eslint-enable no-param-reassign */
const { reducer } = employerOnboardingSlice;
export default reducer;
export const { setCurrentScreen, resetState } = employerOnboardingSlice.actions;
export const employerOnboardingSelector = (state: RootState) =>
  state.employerOnboarding;
export const userDetailSelector = (state: RootState) => state.auth.user;
